import * as Yup from 'yup';
import { DictionaryWaterFlow } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryWaterFlow>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
